import React from "react";
// import { BrowserRouter as Router} from "react-router-dom";
import { Route, Navigate, createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router-dom";
import Home from "./pages/home";

import Signup from "./pages/register/signup";
import ProtectedRoutes from "./pages/routes/ProtectedRoute";
import PublicRoutes from "./pages/routes/PublicRoute";
import Dashboard from "./pages/dashboard";

import Signin from "./pages/register/signin";
import Step2 from "./pages/register/signin/phone/Step2";

import { AuthProvider } from "./context/AuthContext";
import ResetPassword from "./pages/register/resetpassword";
import Invitation from "./pages/Invitation";
import FontLoader from "./components/FontLoader";
import { LeftbarProvider } from "./context/LeftSidebarContext";
import Acknowlaged from "./pages/home/acknowladge";

// import Dashboard from "./components/Dashboard";
// import PrivateRoute from "./components/PrivateRoute";
// import logo from "./logo.svg";
// import "./App.css";

function App() {
  // useEffect(() => {
  //   onAuthStateChanged(auth, user => {
  //     console.log("Auth Chnaged ", auth.currentUser);
  //   });
  // }, []);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route element={<PublicRoutes />}>
          <Route path="/" element={<Home />} />
          <Route path="/accept" element={<Acknowlaged />} />
          <Route path="/signin/*" element={<Signin />} />
          <Route path="/signup/*" element={<Signup />} />
          <Route path="/verifyPhone" element={<Step2 />} />
          <Route path="/resetPassword/*" element={<ResetPassword />} />
          <Route path="/verifyEmail" element={<Navigate to="/signup/verifyEmail" replace />} />
        </Route>
        <Route path="/invitation/:id" element={<Invitation />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/dashboard/*" element={<Dashboard />} />
        </Route>
      </>
    )
  );

  return (
    <LeftbarProvider>
      <AuthProvider>
        {/* <SignupProvider> */}
        <FontLoader />
        <RouterProvider router={router} />
        {/* </SignupProvider> */}
      </AuthProvider>
    </LeftbarProvider>
  );
}

export default App;
